// extracted by mini-css-extract-plugin
export default {"banner":"eKHUUg4IMv_gQX13vEUp","section":"tBHAjLyoYvzoocpJHCVU"};